// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__m1SyM","container":"styles_container__1Ox71","title":"styles_title__3BUpP","wrapper":"styles_wrapper__2H-zS","answer":"styles_answer__1scZT"};